<div class="accordion-container">
	<mat-accordion>
		<mat-expansion-panel class="branding--section-card">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<div class="expansion-panel-header-container">
						<div class="expansion-panel-header-title">
							<h2>
								{{ "ORDER_BASKET.MATERIAL_PANEL.TITLE" | translate }}
								({{ materials.length || 0 }})
							</h2>
						</div>
					</div>
				</mat-panel-title>
				<mat-panel-description *ngIf="!orderId">
					{{ "ORDER_BASKET.MATERIAL_PANEL.DESCRIPTION" | translate }}
				</mat-panel-description>
			</mat-expansion-panel-header>
			<ng-template matExpansionPanelContent>
				<div class="material-item-list-container">
					<ng-container *ngIf="orderId">
						<ng-container *ngFor="let material of materials">
							<div class="static-item text-center">
								<a href="javascript:void(0)" class="cursor-pointer material-box"
								   (click)="handlePrintOrderMaterialClick(material)">
									<ng-container *ngIf="!(material.fullMaterialId)">
										<div class="material-not-found-container">
											<button mat-button class="image-upload-button">
												<mat-icon fontIcon="upload"></mat-icon>
												{{ "ACTION_BUTTON_LABELS.UPLOAD" | translate }}
											</button>
										</div>
									</ng-container>
									<ng-container *ngIf="material.fullMaterialId">
										<div class="image-placeholder">
											<img *cassRefresh="orderHelperService.isMaterialPanelReloadRequired$ | async"
												 [src]="(material.updatedPreviewUrl | publicOrSecureImageLoader:material.previewUrl | async)"
												 style="border:1px dotted gray;" alt="">
										</div>
									</ng-container>
								</a>
								<p>{{ material.fullMaterialId }}</p>
								<p>{{ material.sizeColumnData }}</p>
								<p>{{ material.orderLine.materialDeadline | cassTimestamp }}</p>
								<p class="material-status" [ngClass]="{ 'material-done': material.isDone, 'material-not-done': !material.isDone }">
									<mat-icon>
										{{ material.isDone ? 'check_circle' : 'hourglass_empty' }}
									</mat-icon>
									{{ material.statusText }}
								</p>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</ng-template>
		</mat-expansion-panel>
	</mat-accordion>
</div>
